import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { CompanyDataAccessLayer } from "@/store/modules/access-layers/company.access-layer";

@IsFilterable
class CompanyReferenceEntity implements MrfiktivReferenceGen {
  @FilterConfig({
    displayName: "common.nouns.company",
    type: FilterTypes.OBJECT_ID,
    config: {
      itemCallback: () => CompanyDataAccessLayer.entities,
      mapItemToComponent: item => ({ item }),
      itemValue: "id",
      component: "refs-company"
    }
  })
  refId: string;

  refType: BackendResourceEnum;

  constructor(sharedContent?: Partial<ICompanyReference>) {
    this.refId = sharedContent?.refId || "";
    this.refType = sharedContent?.refType as BackendResourceEnum;
  }
}
type ICompanyReference = CompanyReferenceEntity;
const CompanyReference = Filter.createForClass(CompanyReferenceEntity);

export { ICompanyReference, CompanyReference };
